// extracted by mini-css-extract-plugin
export default {"messageWrapper":"Notification_messageWrapper__KR9Rt","message":"Notification_message__iUHOw"};